var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.58 7.094l-4.936 4.943-.003-10.44H7.358l.004 10.442L2.42 7.102l-.906.907 6.491 6.482 6.483-6.492z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseSmall);
export default __webpack_public_path__ + "static/media/decrease-small.d3ffeb8678c4d175ed25838d0b730f19.svg";
export { ForwardRef as ReactComponent };